export const SMART_CART_AGENT_SURVEY_CUSTOMER_IDS = new Set<number>([
  10000871, 10082235, 10043048, 8950135, 4394578, 9486381, 10081032, 10013609,
  10046791, 8217866, 9438464, 9958183, 2013225, 907077, 5507597, 6405355,
  2173861, 9910606, 9341063, 8063423, 3916814, 9997771, 10086986, 10085416,
  10071371, 6817956, 9848039, 2156273, 10072433, 9959817, 9868627, 9570007,
  7391907, 10000825, 9467728, 6061622, 688783, 5354644, 10060651, 5535213,
  8742616, 9931248, 9609507, 8224666, 9674757, 9697884, 412111, 6885029,
  5845167, 9691143, 5304523, 10075993, 9221051, 9403587, 9669690, 9867540,
  10065586, 1733491, 10057329, 10079594, 9744742, 2387782, 10024458, 10044048,
  9696257, 10076514, 9565659, 9503407, 6150320, 7032037, 9378183, 9938757,
  5624628, 9799813, 1388186, 9878211, 5208108, 9698628, 10049376, 6742142,
  9330747, 10051310, 9999218, 10020410, 4147201, 7278372, 9970362, 10079529,
  9654803, 9750618, 9706795, 9247897, 10006052, 10062901, 9719161, 8365031,
  9931026, 7814551, 2066658, 9900057, 10070686, 10075315, 10040692, 8524757,
  10017462, 8722116, 10080448, 10036473, 9735417, 7948111, 9595485, 1440725,
  10051064, 8968675, 6360185, 7512557, 9892397, 9463872, 10058356, 7710349,
  9378269, 10043563, 7968562, 10047327, 9935065, 9220336, 2249532, 1147157,
  9527540, 9800051, 7475228, 6984283, 8546897, 4595058, 706523,
]);

export function isSmartCartAgentSurveyCustomerId(customerId: number): boolean {
  return SMART_CART_AGENT_SURVEY_CUSTOMER_IDS.has(customerId);
}
